module.exports = __webpack_public_path__ + "img/dislike-small.fc881a4b.svg";